import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import DriverDeliveries from './DriverDeliveries';
import DriverDeliverySign from './DriverDeliverySign';

export const DriverDeliveriesRoutes = (
  <Route path="deliveries" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Driver']}>
          <DriverDeliveries />
        </PrivateRoute>
            )}
    />

    <Route
      path="sign"
      element={(
        <PrivateRoute roles={['Driver']}>
          <DriverDeliverySign />
        </PrivateRoute>
      )}
    />
  </Route>
);
